import PropTypes from "prop-types";

const SelectAllButton = props => {
  const {
    openFacet: { hasSelectedValues, facetType },
    className,
    iconClassName,
    onClick,
    children,
    disabled
  } = props;

  const isDisabled = disabled || hasSelectedValues || facetType === "Range";

  return (
    <button
      data-auto-id="all"
      className={className}
      onClick={onClick}
      disabled={isDisabled}
    >
      <span className={iconClassName} aria-hidden="true"></span>
      {children}
    </button>
  );
};

SelectAllButton.propTypes = {
  className: PropTypes.string.isRequired,
  iconClassName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  openFacet: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default SelectAllButton;
